import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import SpasPage from "./pages/SpasPage";
import SpaDetailPage from "./pages/SpaDetailPage";
import ComparePage from "./pages/ComparePage";
import AccessoiresPage from "./pages/AccessoiresPage";
import AccessoiresCategoryPage from "./pages/AccessoiresCategoryPage";
import PartsCategoryPage from "./pages/PartsCategoryPage";
import PartDetailPage from "./pages/PartDetailPage";
import PiecesHubPage from "./pages/PiecesHubPage";
import AccessoiresSpaPage from "./pages/AccessoiresSpaPage";
import EntretienSpaPage from "./pages/EntretienSpaPage";
import PiecesDetacheesPage from "./pages/PiecesDetacheesPage";
import PompesChaleurPage from "./pages/PompesChaleurPage";
import RemplacementPompeNantesPage from "./pages/RemplacementPompeNantesPage";
import DevisPage from "./pages/DevisPage";
import ContactPage from "./pages/ContactPage";
import FAQPage from "./pages/FAQPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import AboutPage from "./pages/AboutPage";
import LocalSeoPage from "./pages/LocalSeoPage";
import CartPage from "./pages/CartPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelledPage from "./pages/PaymentCancelledPage";
import SpaCategoryPage from "./pages/SpaCategoryPage";
import CGVPage from "./pages/CGVPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import ConfidentialitePage from "./pages/ConfidentialitePage";
import CouvertureSurMesurePage from "./pages/CouvertureSurMesurePage";
import FiltresSpaPage from "./pages/FiltresSpaPage";
import GarantiesEngagementsPage from "./pages/GarantiesEngagementsPage";
import AdminCommandesPage from "./pages/AdminCommandesPage";
import AdminClientsPage from "./pages/AdminClientsPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminFacturesPage from "./pages/AdminFacturesPage";
import { initGA4 } from "./utils/analytics";
import "./App.css";

// Initialize Google Analytics 4
initGA4();

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/spas" element={<SpasPage />} />
          <Route path="/spas/:slug" element={<SpaDetailPage />} />
          <Route path="/comparer" element={<ComparePage />} />
          
          {/* Spa category pages */}
          <Route path="/spas-2-3-places" element={<SpaCategoryPage />} />
          <Route path="/spas-4-5-places" element={<SpaCategoryPage />} />
          <Route path="/spas-6-places-et-plus" element={<SpaCategoryPage />} />
          <Route path="/spas-debordement" element={<SpaCategoryPage />} />
          <Route path="/spas-de-nage" element={<SpaCategoryPage />} />
          <Route path="/ice-bath" element={<SpaCategoryPage />} />
          
          {/* Hub page - Main entry for pieces & accessories */}
          <Route path="/pieces-accessoires" element={<PiecesHubPage />} />
          <Route path="/pieces-accessoires/:slug" element={<PartDetailPage />} />
          
          {/* Pièces détachées routes */}
          <Route path="/pieces-detachees" element={<PartsCategoryPage />} />
          <Route path="/pieces-detachees/:subcategory" element={<PartsCategoryPage />} />
          
          {/* Pièces détachées spa routes */}
          <Route path="/pieces-detachees-spa" element={<PiecesDetacheesPage />} />
          
          {/* Accessoires spa routes */}
          <Route path="/accessoires-spa" element={<AccessoiresSpaPage />} />
          <Route path="/accessoires-spa/:subcategory" element={<AccessoiresSpaPage />} />
          
          {/* Couverture sur mesure */}
          <Route path="/couverture-spa-sur-mesure" element={<CouvertureSurMesurePage />} />
          
          {/* Entretien spa routes */}
          <Route path="/entretien-spa" element={<EntretienSpaPage />} />
          <Route path="/entretien-spa/:subcategory" element={<EntretienSpaPage />} />
          
          {/* Filtres spa - dedicated page */}
          <Route path="/filtres-spa" element={<FiltresSpaPage />} />
          
          {/* Pompes à chaleur spa */}
          <Route path="/pompes-a-chaleur-spa" element={<PompesChaleurPage />} />
          <Route path="/pompes-a-chaleur-spa/:slug" element={<PartDetailPage />} />
          
          {/* Legacy accessoires route - redirect to hub or entretien */}
          <Route path="/accessoires" element={<EntretienSpaPage />} />
          <Route path="/accessoires/:subcategory" element={<EntretienSpaPage />} />
          
          {/* Part detail pages */}
          <Route path="/:category/:subcategory/:slug" element={<PartDetailPage />} />
          
          {/* Strategic SEO page */}
          <Route path="/remplacement-pompe-spa-nantes" element={<RemplacementPompeNantesPage />} />
          
          {/* Cart */}
          <Route path="/panier" element={<CartPage />} />
          <Route path="/paiement-succes" element={<PaymentSuccessPage />} />
          <Route path="/paiement-annule" element={<PaymentCancelledPage />} />
          
          <Route path="/devis" element={<DevisPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/a-propos" element={<AboutPage />} />
          <Route path="/spa-nantes" element={<LocalSeoPage />} />
          <Route path="/spa-vendee" element={<LocalSeoPage />} />
          <Route path="/spa-morbihan" element={<LocalSeoPage />} />
          <Route path="/spa-maine-et-loire" element={<LocalSeoPage />} />
          
          {/* Pages institutionnelles */}
          <Route path="/cgv" element={<CGVPage />} />
          <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
          <Route path="/confidentialite" element={<ConfidentialitePage />} />
          <Route path="/garanties-engagements" element={<GarantiesEngagementsPage />} />
          
          {/* Admin */}
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/admin/commandes" element={<AdminCommandesPage />} />
          <Route path="/admin/clients" element={<AdminClientsPage />} />
          <Route path="/admin/factures" element={<AdminFacturesPage />} />
        </Routes>
      </Layout>
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
